// AI-CONTEXT: See docs/features/livereport-templates-deelnemer.md (T3)
// Namen van meetmomenten per positie ("1" → "Voormeting"). Eén regel voor de
// Firestore-route (getMomentTitlesByPosition) en de templateroute
// (useMatrixData met templateData), die anders bij de verkeerde organisatie zocht.

/**
 * @param {Array<{ResearchID?: string, Position?: number|string, Title?: string, Deleted?: boolean}>} moments
 * @param {Array<string>} researchIds
 * @returns {Object<number, string>}
 */
const momentTitlesByPosition = (moments, researchIds) => {
    const ids = new Set((researchIds || []).filter(Boolean))
    const sorted = (moments || [])
        .filter((m) => m && !m.Deleted && ids.has(m.ResearchID)) // soft-deleted (ADR-008)
        .map((m) => ({ ...m, pos: typeof m.Position === 'number' ? m.Position : parseInt(m.Position, 10) }))
        .sort((a, b) => a.pos - b.pos)
    const pos2title = {}
    sorted.forEach((m) => {
        if (!Number.isNaN(m.pos) && m.Title && pos2title[m.pos] === undefined) pos2title[m.pos] = m.Title
    })
    return pos2title
}

export default momentTitlesByPosition
